import { configureStore } from "@reduxjs/toolkit";
import favouritesReducer from './favouritesSlice.js';
import metricsReducer from './metricsSlice.js'
import runtimeReducer from './runtimeSlice.js';  // Import runtime slice


/* Global Redux store
*  Rensponsibility:  
*  - Contains all the slices (small part of the whole store)
*  - configureStore -> Sets up the Redux store, middleware (Thunk) and integrates dev-tools.
*/


const store = configureStore({
  reducer: {
    //? Here the favouritesSlice from `./favouritesSlice` gets registered in the global state obj
    favourites: favouritesReducer, //* enables state.favourites.favouritesArray ..etc..
    metrics: metricsReducer,
    runtime: runtimeReducer,  // Register runtime slice
  },
});


// ================ Persistent *local* storage ================ 

//? Load from storage on Startup
const savedData = localStorage.getItem('favouritesArray');
if (savedData) {
  const parsed = JSON.parse(savedData);

  //? Custom Action to save data into JSON in the localStore.
  store.dispatch({
    type: 'favourites/loadFromStorage',
    payload: parsed,
  });
}

//? Save to localStorage on every change
store.subscribe(() => {
  const state = store.getState();
  localStorage.setItem(
    'favouritesArray',
    JSON.stringify(state.favourites.favouritesArray)
  );
});

export default store;
